'use strict';

import * as util from '../util/Common.js';
import * as domUtil from '../util/Dom.js';
import * as iiifUtil from '../util/IIIFUtil.js';

const privateMap = util.createPrivateMapper();

export const DataTypes = {
  Link: 0, // Symbol('Value type link'),
  Text: 1, // Symbol('Value type text'),
  Image: 2 // Symbol('Value type image')
}

export function getLang(textObj){
  let hasValue = false;
  const langValue = {}
  const langMap = {};
  langValue.langMap = langMap;
  const v = textObj.text;
  for (let k in v) {
    const l = v[k].length;
    const langValues = [];
    for (let i = 0; i < l; i++) {
      const domV = iiifUtil.weakDomParse(v[k][i]);
      if (!domV) {
        continue;
      }
      langValues[langValues.length] = domV;
    }
    if (!langValues.length) {
      continue;
    }
    let el;
    if (langValues.length == 1) {
      el = langValues[0];
    } else {
      const ul = domUtil.createElement('ul');
      const l = langValues.length;
      for (let i = 0; i < l; i++) {
        const li = domUtil.createElement('li');
        li.appendChild(langValues[i])
        ul.appendChild(li);
      }
      el = ul
    }
    langMap[k] = el;
    if (!hasValue) {
      langValue.domEl = el;
      langValue.defaultValue = el
    }
    hasValue = true;
  }

  if (!hasValue) {
    return;
  }
  return langValue;
};
export const getDomItem = function(v) {
  let domItem;
  if (!v) {
    return;
  }
  switch (v.type) {
  case DataTypes.Text:
    domItem = getLang(v);
    break;
  case DataTypes.Link:
    let label = v.label;
    if (v.format) {
      label += '(' + v.format + ')';
    }
    const link = domUtil.createElement('a');
    link.appendChild(domUtil.text(label));

    domUtil.setAttr(link, 'href', v.url);
    domUtil.setAttr(link, 'target', '_blank');
    domItem = {
      domEl: link
    };
    break;
  case DataTypes.Image:
    const img = domUtil.createElement('img');
    domUtil.setAttr(img, 'src', v.src);
    domItem = {
      domEl: img
    };
    break;
  }
  return domItem;
};
